export default __webpack_public_path__ + "static/media/joe_casabona.8129ac60.png";